// extracted by mini-css-extract-plugin
export var dropdownIcon = "_na-6";
export var imgContainer = "_na-3";
export var menuIcon = "_na-5";
export var pillWrapper = "_na-2";
export var pillsContainer = "_na-1";
export var subscriptionCard = "_na-0";
export var subscriptionLogo = "_na-4";